import styled from 'styled-components';

const FormButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
`;

export default FormButtonWrapper;



// WEBPACK FOOTER //
// ./src/components/atoms/form/FormButtonWrapper.js